import React, { Component } from 'react';
import { Grid, Row, Col, Form, FormGroup, FormControl, ControlLabel, ButtonToolbar, Button } from 'react-bootstrap'
import Select from "react-select";

import { LayoutFormatHelper } from '../helpers/LayoutFormatHelper';

export class LayoutConfigurationProperties extends Component {
    constructor(props) {
        super(props);

        this.state = {
            layout: LayoutFormatHelper.createLayoutObject(this.props.layout),
            inputNameStyle: null
        };
    }

    // -----------------------

    componentWillReceiveProps(nextProps) {
        const { layout } = this.state;

        if (nextProps.layout.toInitialState) {
            this.setState({
                layout: LayoutFormatHelper.createLayoutObject(nextProps.layout),
                inputNameStyle: nextProps.inputNameStyle
            });
        }
    }

    // -----------------------

    onChangeValue(e, target) {
        const { layout } = this.state;
        layout[target] = e.target.value;

        this.setState({
            layout: layout
        }, () => {
            this.onSave();
        });
    }

    onSelectValue(e, target) {
        const { layout } = this.state;

        layout[target] = null === e ? "" : e;

        this.setState({
            layout: layout
        }, () => {
            this.onSave();
        });
    }

    onSave() {
        if (null !== this.props.onSaveLayoutProperties && undefined !== this.props.onSaveLayoutProperties) {
            const { layout } = this.state;
            this.setState({
                layout: layout,
            },
            this.props.onSaveLayoutProperties(LayoutFormatHelper.getLayoutPropertiesObject(layout.name, layout.format, layout.orientation)));
        }
    }

    render() {
        const { layout, inputNameStyle } = this.state;

        return (
            <Grid fluid>
                <Row>
                    <Form>
                        <Col sm={6}>
                            <FormGroup bsSize="small" controlId="formLayoutName"
                                validationState={inputNameStyle} >
                                <ControlLabel>Nome</ControlLabel>
                                <FormControl
                                    type="text"
                                    placeholder="Nome do Layout"
                                    value={layout.name}
                                    onChange={(e) => this.onChangeValue(e, 'name')} />
                            </FormGroup>
                        </Col>

                        <Col sm={3}>
                            <FormGroup bsSize="small" controlId="formLayoutFormat">
                                <ControlLabel>Formato</ControlLabel>
                                <Select
                                    className="custom-multiselect custom-multiselect-small"
                                    placeholder="Formato"
                                    noOptionsMessage={() => "Sem Formatos Configurados"}
                                    onChange={(e) => this.onSelectValue(e, "format")}
                                    options={["A4", "A5"]}
                                    isMulti={false}
                                    isClearable={false}
                                    isOptionSelected={function (a) {
                                        return layout.format === a;
                                    }}
                                    getOptionValue={value => value}
                                    getOptionLabel={label => label}
                                    value={[layout.format]}
                                />
                            </FormGroup>
                        </Col>

                        <Col sm={3}>
                            <FormGroup bsSize="small" controlId="formLayoutOrentation">
                                <ControlLabel>Orientação</ControlLabel>
                                <div>
                                    <ButtonToolbar>
                                        <Button title="Horizontal"
                                            bsSize="xsmall"
                                            active={"Horizontal" === layout.orientation}
                                            onClick={() => this.onChangeValue({ target: { value: "Horizontal" } }, "orientation")} >
                                            <div className="icon-horizontal icon-img"></div>
                                        </Button>
                                        <Button title="Vertical"
                                            bsSize="xsmall"
                                            active={"Vertical" === layout.orientation}
                                            onClick={() => this.onChangeValue({ target: { value: "Vertical" } }, "orientation")} >
                                            <div className="icon-vertical icon-img"></div>
                                        </Button>
                                    </ButtonToolbar>
                                </div>
                            </FormGroup>
                        </Col>
                    </Form>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/LayoutConfigurationProperties.js